module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.clusterInfoTitle,
      "width": "35%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "clusterInfo",
    attrs: {
      "model": _vm.clusterInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "集群ID",
      "prop": "zkClusterKey"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.clusterInfo.zkClusterKey),
      callback: function($$v) {
        _vm.$set(_vm.clusterInfo, "zkClusterKey", $$v)
      },
      expression: "clusterInfo.zkClusterKey"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "集群名称",
      "prop": "alias"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.clusterInfo.alias),
      callback: function($$v) {
        _vm.$set(_vm.clusterInfo, "alias", $$v)
      },
      expression: "clusterInfo.alias"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "集群描述",
      "prop": "description"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入机房信息"
    },
    model: {
      value: (_vm.clusterInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.clusterInfo, "description", $$v)
      },
      expression: "clusterInfo.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "连接串",
      "prop": "connectString"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "连接串用','分隔"
    },
    model: {
      value: (_vm.clusterInfo.connectString),
      callback: function($$v) {
        _vm.$set(_vm.clusterInfo, "connectString", $$v)
      },
      expression: "clusterInfo.connectString"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-annotation"
  }, [_c('span', [_vm._v("格式: 例如192.168.0.1:2181,192.168.0.2:2181")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d1a718"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/registry_manage/cluster_info_dialog.vue
// module id = 1402
// module chunks = 1